import { render, staticRenderFns } from "./ChatProfileCard.vue?vue&type=template&id=c60678da&scoped=true&"
import script from "./ChatProfileCard.vue?vue&type=script&lang=js&"
export * from "./ChatProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatProfileCard.vue?vue&type=style&index=0&id=c60678da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60678da",
  null
  
)

export default component.exports